

export const base64File = (base64String) => {
    if (!base64String) {
        return
    }

    const data = base64String.substring(0, 5).toUpperCase();

    switch (data) {
        case "IVBOR":
            // png
            return "data:image/png;base64," + base64String;
        case "/9J/4":
            // jpg
            return "data:image/jpeg;base64," + base64String;
        case "/9J/":
            // jpg
            return "data:image/jpeg;base64," + base64String;
        case "AAAAF":
            //mp4
            return "data:video/mp4;base64," + base64String;
        case "JVBER":
            // pdf
            return "data:application/pdf;base64," + base64String;
        case "AAABA":
            // ico;
            return "data:image/x-icon;base64," + base64String;
        case "UMFYI":
            //    rar;
            return "data:application/x-rar-compressed;base64," + base64String;
        case "UEsFB":
            // zip
            return "data:application/zip;base64," + base64String;
        case "E1XYD":
            // rtf
            return "data:application/rtf;base64," + base64String;
        case "U1PKC":
            //text
            return "data:text/plain;base64," + base64String;
        case "MQOWM":
        case "77U/M":
            // srt
            return "data:text/srt;base64," + base64String;
        default:
            return '';
    }
}
